'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/CurrencyCircleDollar.es.js";
const e = a.forwardRef((o, c) => /* @__PURE__ */ a.createElement(p, { ref: c, ...o, weights: e$1 }));
e.displayName = "CurrencyCircleDollarIcon";
const i = e;
export {
  i as CurrencyCircleDollar,
  e as CurrencyCircleDollarIcon
};
